// Course Configuration
// This file centralizes all course definitions and makes it easy to add new courses

export const COURSES = {
  '90-day-journey': {
    id: '7b4b95e8-8bd7-4606-82af-cc725d46c17d',
    title: 'Your 90-Day Journey',
    description: 'Complete wellness journey over 90 days',
    buttonText: 'Your 90-Day Journey',
    buttonClass: 'course-banner journey-banner',
    completionMessage: '90 Day Journey Complete!',
    dayLabel: 'Day',
    totalLabel: 'Days'
  },
  'first-two-weeks': {
    id: 'e2b654c7-4ed4-4482-9a65-441ff97859e4', // Replace with actual course ID
    title: 'My First Two Weeks',
    description: 'Essential wellness foundation for your first two weeks',
    buttonText: 'My First Two Weeks',
    buttonClass: 'course-banner first-two-weeks',
    completionMessage: 'First Two Weeks Complete!',
    dayLabel: 'Day',
    totalLabel: 'Days'
  }
  // Add more courses here as needed
};

export const getCourseConfig = (courseKey) => {
  return COURSES[courseKey] || null;
};

export const getAllCourseKeys = () => {
  return Object.keys(COURSES);
};

export const getCourseById = (courseId) => {
  return Object.values(COURSES).find(course => course.id === courseId) || null;
}; 